module.exports = __webpack_public_path__ + "img/project.b5526e40.svg";